module.exports = __webpack_public_path__ + "img/infogandesortering.8782068f.jpg";